import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class TableHeaderCell extends PureComponent {
  state = {
    direction: 'asc',
  };

  onHandleSort = (e) => {
    const { handleSort } = this.props;
    const { direction } = this.state;
    const { currentTarget: { id: name } } = e;
    const newDirection = direction === 'asc' ? 'desc' : 'asc';

    this.setState({
      direction: newDirection,
    });

    handleSort(name, newDirection);
  };

  render() {
    const {
      children,
      sort,
      align,
      sortingId,
    } = this.props;
    const { direction } = this.state;

    return sort ? (
      <th
        id={sortingId}
        align={align}
        onClick={this.onHandleSort}
        className="cursor-pointer"
      >
        {children}

        {direction === 'asc' && <i className="fa fa-chevron-up pl-2" />}
        {direction === 'desc' && <i className="fa fa-chevron-down pl-2" />}
      </th>
    ) : (
      <th align={align}>
        {children}
      </th>
    );
  }
}

TableHeaderCell.propTypes = {
  children: PropTypes.node.isRequired,
  sortingId: PropTypes.string.isRequired,
  handleSort: PropTypes.func,
  sort: PropTypes.bool,
  align: PropTypes.string,
};

TableHeaderCell.defaultProps = {
  sort: false,
  align: 'left',
  handleSort: () => { },
};

export default TableHeaderCell;
